import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const vaccinationLocaleModule: LocaleModule = {
  name: "vaccination",
  messages: { en: en, it: it },
};
